import Header from "components/HeaderHorizontal";
import React, { useEffect, useState, useContext } from "react";
import { Carousel, Card, Form, Button } from "react-bootstrap";

import { GET_LIST_QUIZ, SUBMIT_QUIZ } from "services/Quiz";
import CardInfo from "components/CardInfo";

import { Context } from "context/AuthContext";
import { useAlert } from "context/AlertContext";
import "./styles.scss";
import HtmlPreview from "components/HTMLExtract";

const ContentQuiz = () => {
  const { showLoader } = useContext(Context);
  const { showAlert } = useAlert();

  const [loading, setLoading] = useState(false);
  const [listQuestoes, setListQuestoes] = useState([]);
  const [index, setIndex] = useState(0);
  const [selectedAnswers, setSelectedAnswers] = useState({});
  const [quizSubmitted, setQuizSubmitted] = useState(false);
  const [results, setResults] = useState(null);

  useEffect(() => {
    setLoading(true);
    showLoader(true);

    const fetchQuiz = async () => {
      try {
        const data = await GET_LIST_QUIZ();
        setListQuestoes(data.value.questoes);
      } catch (error) {
        console.error("Erro ao buscar o quiz:", error);
      } finally {
        setLoading(false);
        showLoader(false);
      }
    };

    fetchQuiz();
  }, []);

  const submitQuiz = async () => {
    showLoader(true);
    if (Object.keys(selectedAnswers).length < listQuestoes.length) {
      {
        <div>
          {showAlert(
            "Responda todas as questões antes de finalizar o quiz.",
            "danger"
          )}
        </div>;
      }

      showLoader(false);
      return;
    }

    try {
      const respostas = Object.entries(selectedAnswers).map(
        ([questaoId, respostaId]) => ({
          questaoId: parseInt(questaoId),
          respostaId: parseInt(respostaId),
        })
      );

      const data = { respostas };
      const response = await SUBMIT_QUIZ(data);

      setResults({
        numCorrect: response.data.value.acertos,
        numIncorrect: listQuestoes.length - response.data.value.acertos,
      });
      setQuizSubmitted(true);
      showLoader(false);
    } catch (error) {
      console.error("Erro ao submeter o quiz:", error);
      showLoader(false);
    }
  };

  const handlePrev = () => {
    if (index > 0) {
      setIndex(index - 1);
    }
  };

  const handleNext = () => {
    if (index < listQuestoes.length - 1) {
      setIndex(index + 1);
    }
  };

  const handleSelectAnswer = (questaoId, respostaId) => {
    setSelectedAnswers({
      ...selectedAnswers,
      [questaoId]: respostaId,
    });
  };

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  return (
    <div className="quiz-wrapper">
      <Header />
      {quizSubmitted && results && (
        <div className="results-content ">
          <CardInfo
            title={`Você acertou ${results.numCorrect} de ${listQuestoes.length} questões.`}
            text="Clique no botão abaixo para ver o gabarito."
            img=""
            link="/resumo"
            textBtn="Ver Gabarito"
          />
        </div>
      )}
      {!quizSubmitted && (
        <div className="quiz-container">
          {loading ? (
            <p className="d-flex justify-content-center align-items-center">
              Carregando...
            </p>
          ) : listQuestoes.length === 0 ? (
            <p className="d-flex justify-content-center">
              Nenhuma questão encontrada.
            </p>
          ) : (
            <div className="quiz-content">
              <Carousel
                activeIndex={index}
                onSelect={handleSelect}
                indicators={false}
                interval={null}
                nextIcon={null}
                prevIcon={null}
                touch={false}
              >
                {listQuestoes.map((questao) => (
                  <Carousel.Item key={questao.questaoId}>
                    <div className="quiz-container-cards">
                      <Card className="question-card-quiz m-4">
                        <Card.Subtitle className="question-subtitle-quiz">
                          {questao.categoriasTree.reduce((acc, categoria, index) => {
                            // Extrai a primeira parte da string até o primeiro "-"
                            const baseCategoria = categoria.split(" - ")[0];

                            // Adiciona a categoria completa somente se a base ainda não foi processada
                            if (index === 0 || baseCategoria !== acc.baseAnterior) {
                              acc.texto += categoria + " ";
                              acc.baseAnterior = baseCategoria;
                            } else {
                              // Caso seja uma repetição, adiciona apenas o texto após o " - "
                              acc.texto += " - " + categoria.split(" - ")[1] + "";
                            }
                            return acc;
                          }, { texto: "", baseAnterior: "" }).texto}
                        </Card.Subtitle>
                        <Card.Body
                          key={questao.questaoId}
                          className="question-container-quiz"
                        >
                          {/* USADO PARA MOSTRAR CONTEUDO CRIADO NO JODIT EDITOR */}
                          <HtmlPreview
                            htmlContent={questao.enunciado}
                            mode="card"
                          />
                        </Card.Body>
                      </Card>
                      {/* <div className="vertical-line"></div> */}
                      <Card className="answer-card-quiz m-4">
                        <Card.Body>
                          {questao.respostas.map((resposta) => (
                            <div
                              key={resposta.respostaId}
                              className={`answer-container-quiz ${selectedAnswers[questao.questaoId] ===
                                resposta.respostaId
                                ? "selected-answer"
                                : ""
                                } ${resposta.texto.length > 2
                                  ? "justify-content-start"
                                  : " justify-content-center"
                                }
                              
                              `}
                            >
                              <Form.Check
                                type="radio"
                                id={`questao-${questao.questaoId}-${resposta.respostaId}`}
                              >
                                <div className="answer-content-quiz">
                                  <Form.Check.Input
                                    type="radio"
                                    name={`questao-${questao.questaoId}`}
                                    checked={
                                      selectedAnswers[questao.questaoId] ===
                                      resposta.respostaId
                                    }
                                    onChange={() =>
                                      handleSelectAnswer(
                                        questao.questaoId,
                                        resposta.respostaId
                                      )
                                    }
                                  />
                                  <Form.Check.Label
                                    className="answer-label-quiz"
                                    htmlFor={`questao-${questao.questaoId}-${resposta.respostaId}`}
                                  >
                                    <Form.Text className="answer-text-quiz">
                                      {resposta.texto}
                                    </Form.Text>
                                  </Form.Check.Label>
                                </div>
                              </Form.Check>
                            </div>
                          ))}
                        </Card.Body>
                      </Card>
                    </div>
                  </Carousel.Item>
                ))}
              </Carousel>
              {/* Botões de navegação abaixo do Carousel */}
              <div className="content-btn-quiz">
                <Button
                  variant="primary"
                  onClick={handlePrev}
                  disabled={index === 0}
                  className="btn-quiz"
                >
                  Voltar
                </Button>
                {/* Indicadores personalizados */}
                <div className="d-flex flex-column justify-content-center align-items-center m-0">
                  <span>
                    {index + 1} de {listQuestoes.length}
                  </span>
                  <div className="carousel-indicators-custom-quiz">
                    {listQuestoes.map((questao, idx) => (
                      <span
                        key={idx}
                        className={`carousel-indicator ${selectedAnswers[questao.questaoId] ? "active" : ""
                          } ${index === idx ? "current-step" : ""}`}
                        onClick={() => setIndex(idx)}
                      />
                    ))}
                  </div>
                </div>
                {index === listQuestoes.length - 1 ? (
                  <Button
                    variant="primary"
                    onClick={submitQuiz}
                    className="btn-quiz"
                  >
                    Finalizar
                  </Button>
                ) : (
                  <Button
                    variant="primary"
                    onClick={handleNext}
                    className="btn-quiz"
                  >
                    Próximo
                  </Button>
                )}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ContentQuiz;
